import { Route } from "vue-router"
import { ROUTER_NAME } from "../../../client/router"

export class Activity {
    readonly id: number
    readonly action: string
    readonly objectType: string
    readonly objectId: number
    readonly createdAt: Date
    readonly data?: {
        times: number
    }
    readonly objectData: {
        title: string
        courseId?: string
        lessonId?: string
        questionId?: string
        examId?: string
        blogId?: string
        premiumServiceId?: string
    }

    constructor(data: { [key: string]: any }) {
        this.id = data.id
        this.action = data.action
        this.objectType = data.objectType
        this.objectId = data.objectId
        this.createdAt = new Date(data.createdAt)
        this.data = data.data
        this.objectData = data.objectData
    }

    get title() : string {
        return this.objectData.title
    }

    get link() : Partial<Route> | null {
        if (this.objectData.courseId) {
            return {
                name: ROUTER_NAME.MY_COURSE_DETAIL,
                params: {
                    courseId: this.objectData.courseId,
                },
                query: {
                    lesson_id: this.objectData.lessonId,
                }
            }
        } 
        else if (this.objectData.questionId) {
            return {
                name: ROUTER_NAME.USER_QUESTION_DETAIL,
                params: {
                    questionId: this.objectData.questionId
                }
            }
        }
        else if (this.objectData.examId) {
            return {
                name: ROUTER_NAME.EXAM_DETAIL,
                params: {
                    examId: this.objectData.examId
                }
            }
        }
        else if (this.objectData.blogId) {
            // TODO Blogはvuejsになっていません
            return null
        }
        else if (this.objectData.premiumServiceId) {
            // TODO Blogはvuejsになっていません
            return null
        }

        return null
    }
    get externalLink() : string | null {
        if (this.objectData.blogId) {
            return `/blogs/${this.objectData.premiumServiceId}`
        }
        else if (this.objectData.premiumServiceId) {
            return `/premium_services/${this.objectData.premiumServiceId}`
        }
        return null
    }
}
export class Tracking {
    readonly id: number
    readonly trackingDate: Date
    public totalRecordedValue: number
    public totalExamValue: number

    constructor(data: { [key: string]: any }) {
        this.id = data.id
        this.trackingDate = new Date(data.trackingDate)
        this.totalRecordedValue = data.totalRecordedValue
        this.totalExamValue = data.totalExamValue
    }

    get timeValue(){
        const minutes = Math.round(this.totalRecordedValue / 60)
        const hours = Math.floor(minutes / 60)

        var realMinute = minutes - hours * 60

        return {
            hours,
            minutes: realMinute
        }
    }

    static createEmpty(trackingDate: Date){
        return new Tracking({
            id: -1,
            trackingDate,
            totalRecordedValue: 0,
            totalExamValue: 0
        })
    }
}

export default class ActivityData {
    readonly activities: Activity[] = []
    readonly trackingUsers: Tracking[] = []
    readonly isEnd: boolean = false

    constructor(data: { [key: string]: any }) {
        if (data.activities) {
            this.activities = data.activities.map((element) => new Activity(element))
        }
        if (data.trackingUsers) {
            this.trackingUsers = data.trackingUsers.map((element) => new Tracking(element))
        }

        this.isEnd = data.isEnd
    }
}
